// eslint-disable-next-line no-undef

import Routes from "../Routes";
import api from "../axiosApi";
import { initMercadoPago } from '@mercadopago/sdk-react';


class PaymentGatewayAbstract {
    client = undefined;
    constructor() {
        if (PaymentGatewayAbstract.instance) {
            return PaymentGatewayAbstract.instance; // Devuelve la única instancia existente
        }

        PaymentGatewayAbstract.instance = this; // Guarda la instancia en la clase

        return this;
    }

    configure(data) {
        throw new Error("Method 'configure()' must be implemented.");
    }

    open(data) {    
        throw new Error("Method 'open()' must be implemented.");
    }

    getPayment(data) {
        throw new Error("Method 'get()' must be implemented.");
    }
    async open_model_payment(data) {
        const { model, startDate, users, extra_data={}} = data.calendar_data ?? {};

        if (!model || !startDate || !users) {
            throw new Error("Missing required data: model, startDate, or users.");
        }
        if (!model._id || !model.cost) {
            throw new Error("Missing required model data: _id or cost.");
        }
        if (!data.receiverId) {
            throw new Error("Missing required data: payerId or receiverId.");
        }
        delete data.calendar_data;
        
        const data_to_codify ={
            modelId: model._id,
            startDate: startDate.replace(/-/g, "/"),
            users,
            
        }
        
        data.type = "model_itinerary"
        data.resource_id = model._id
        data.data = data_to_codify
        data.extra_data = extra_data
        data.payer_email = extra_data.email ?? ''
        data.extra = {
            itinerary_name: model.name ?? ""
        }
        return await this.open(data)

    }
    async open_agency_unlock(data) {
        const { _id, } = data.agency_data ?? {};

        delete data.agency_data;

        data.currency = `cop`
        data.amount = `${process.env.REACT_APP_AGENCY_UNLOCK_PAYMENT}`
        data.tax_base = `${process.env.REACT_APP_AGENCY_UNLOCK_PAYMENT}`
        data.tax = "0"
        data.tax_ico = `${0}`
        
        const extra_data ={
            agencyId: _id,
            
        }
        
        data.type = "agency_unlock"
        data.resource_id = _id
        data.data = extra_data
        return await this.open(data)

    }

}

class EPaycoService extends PaymentGatewayAbstract {

    configure(data) {
        if (window.ePayco) {
            this.client = window.ePayco.checkout.configure(data);
        }
    }

    async open(data) {
        if (!this.client) 
            throw new Error("Epayco client is not configured. Please call configure() first.");

        const type = data.type

        const dataToSend = {
            external_id: "",
            resource_id: data.resource_id,
            cost: data.amount,
            currency: data.currency,
            commission: data.tax_ico,
            data: data.data,
            extra_data: data.extra_data,
            type: type,
            payer: data.payerId,
            payer_email: data.payer_email,
            receiver: data.receiverId,

        };
        let payment
        try {
            const { data: payment_response } = await api.post("/payments", dataToSend);
            payment = payment_response.data
        } catch (error) {
            throw new Error(
                {
                    message: error.response.data,
                    error: "tripendar_payment_error",
                }
            ) 
        }

        data = {...data, 
            extra1: data.payerId,
            extra2: data.receiverId,
            extra3: payment._id,
            confirmation: `${process.env.REACT_APP_API_URL}/payments/webhook/`, // 
            acepted:`${process.env.REACT_APP_URL}${Routes.processPayment(payment.token)}?accepted=true`,
            rejected: `${process.env.REACT_APP_URL}${Routes.processPayment(payment.token)}?rejected=true`,
            pending: `${process.env.REACT_APP_URL}${Routes.processPayment(payment.token)}?pending=true`,
            response: `${process.env.REACT_APP_URL}${Routes.processPayment(payment.token)}`,
        }
        this.client.open(data);
        
    }

}
class MercadoPagoGateway extends PaymentGatewayAbstract {

    configure(data) {
        // Inicializa Mercado Pago con tu public key
        initMercadoPago(data.key);
    }

    async open(data) {
        const type = data.type

        const dataToSend = {
            external_id: "",
            resource_id: data.resource_id,
            cost: data.amount,
            currency: data.currency,
            commission: data.tax_ico,
            data: data.data,
            extra_data: data.extra_data,
            type: type,
            payer: data.payerId,
            payer_email: data.payer_email,
            receiver: data.receiverId,

        };
        let payment
        try {
            const { data: payment_response } = await api.post("/payments", dataToSend);
            payment = payment_response.data
        } catch (error) {
            throw new Error(
                {
                    message: error.response.data,
                    error: "tripendar_payment_error",
                }
            ) 
        }

        const preference_data = {
            payment_id: payment._id
        }
        if (data.extra && data.extra.itinerary_name) {
            preference_data.itinerary_name = data.extra.itinerary_name
        }
        const { data: payment_response } = await api.post("/payments/mercado-pago/preference", preference_data);
        return payment_response
    }

    async open_model_payment(data) {
        const { model, startDate, users, extra_data={}} = data.calendar_data ?? {};

        if (!model || !startDate || !users) {
            throw new Error("Missing required data: model, startDate, or users.");
        }
        if (!model._id || !model.cost) {
            throw new Error("Missing required model data: _id or cost.");
        }
        if (!data.receiverId) {
            throw new Error("Missing required data: payerId or receiverId.");
        }
        delete data.calendar_data;
        
        const data_to_codify ={
            modelId: model._id,
            startDate: startDate.replace(/-/g, "/"),
            users,
            
        }
        
        data.type = "model_itinerary"
        data.resource_id = model._id
        data.data = data_to_codify
        data.extra_data = extra_data
        data.payer_email = extra_data.email ?? ''
        data.extra = {
            itinerary_name: model?.name ?? ""
        }
        return await this.open(data)

    }
    async open_agency_unlock(data) {
        const { _id, } = data.agency_data ?? {};

        delete data.agency_data;

        data.currency = `cop`
        data.amount = `${process.env.REACT_APP_AGENCY_UNLOCK_PAYMENT}`
        data.tax_base = `${process.env.REACT_APP_AGENCY_UNLOCK_PAYMENT}`
        data.tax = "0"
        data.tax_ico = `${0}`
        
        const extra_data ={
            agencyId: _id,
            
        }
        
        data.type = "agency_unlock"
        data.resource_id = _id
        data.data = extra_data
        return await this.open(data)

    }
}


export default new MercadoPagoGateway();